import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const languages = [
  { code: 'ja', name: '日本語', flag: '🇯🇵', path: '/ja' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳', path: '/zh-cn' },
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼', path: '/zh-tw' },
  { code: 'en', name: 'English', flag: '🇺🇸', path: '/en' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', path: '/ko' },
];

export default function LanguageSwitcher() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  // 根据当前路径确定当前语言
  const getCurrentLanguage = () => {
    const currentPath = location.pathname;
    const lang = languages.find(l => l.path === currentPath);
    return lang || languages[0]; // 默认日语
  };

  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());

  // 当路径变化时更新当前语言
  useEffect(() => {
    setCurrentLanguage(getCurrentLanguage());
  }, [location.pathname]);

  const handleLanguageChange = (lang: typeof languages[0]) => {
    setCurrentLanguage(lang);
    setIsOpen(false);
    navigate(lang.path);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-white hover:bg-gray-50 rounded-lg border border-gray-200 transition-all shadow-sm hover:shadow-md cursor-pointer whitespace-nowrap"
      >
        <span className="text-xl">{currentLanguage.flag}</span>
        <span className="font-medium text-gray-700 hidden sm:inline">{currentLanguage.name}</span>
        <i className={`ri-arrow-down-s-line text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang)}
              className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer ${
                currentLanguage.code === lang.code ? 'bg-blue-50' : ''
              }`}
            >
              <span className="text-xl">{lang.flag}</span>
              <span className={`font-medium ${
                currentLanguage.code === lang.code ? 'text-blue-600' : 'text-gray-700'
              }`}>
                {lang.name}
              </span>
              {currentLanguage.code === lang.code && (
                <i className="ri-check-line text-blue-600 ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
